<template>
    <div class="sketch-content flex">
        <div class="page-content">
            <SketchBreadcrumb pageName="Proiectul în MySMIS"></SketchBreadcrumb>
            <div class="padding-box">
                <MySmisContent :allData="allData"></MySmisContent>
            </div>
        </div>
    </div>
</template>

<script>
import MySmisContent from '../components/mysmis/MySmisContent'
import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
export default {
    components: {
        MySmisContent,
        SketchBreadcrumb
    },
    data() {
        return {
        }
    },
    computed: {
        allData() {
            return this.$store.getters['m3Sketch/allData']
        }
    },
    mounted() {

    },
    methods: {
    }
}
</script>

<style scoped>
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.module-title{
    margin: 0;
    color: #5b6276;
    font-size: 14px;
    margin-bottom: 5px;
}
.white-box{
    width: 100%;
}
.white-box p{
    color: #777e90;
    font-size: 12px;
    margin: 0;
    max-width: 960px;
}
.warning-sign{
    margin-left: 50px;
}
</style>
